import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {DynamicFormComponent} from './containers/dynamic-form/dynamic-form.component';
import {FormButtonComponent} from './components/form-button/form-button.component';
import {FormInputComponent} from './components/form-input/form-input.component';
import {FormTextAreaComponent} from './components/form-textarea/form-textarea.component';
import {FormNumberComponent} from './components/form-number/form-number.component';
import {FormSelectComponent} from './components/form-select/form-select.component';
import {FormAddressComponent} from './components/form-address/form-address.component';
import {DynamicFieldDirective} from './containers/dynamic-field/dynamic-field.directive';
import {FormDateComponent} from './components/form-date/form-date.component';
import {FormPasswordComponent} from './components/form-password/form-password.component';
import {FormLinkComponent} from './components/form-link/form-link.component';
import {RouterModule} from '@angular/router';
import {SpinnerModule} from '../spinner/spinner.module';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
} from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SpinnerModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule
  ],
  declarations: [
    DynamicFieldDirective,
    DynamicFormComponent,
    FormButtonComponent,
    FormInputComponent,
    FormSelectComponent,
    FormAddressComponent,
    FormDateComponent,
    FormPasswordComponent,
    FormLinkComponent,
    FormTextAreaComponent,
    FormNumberComponent
  ],
  exports: [
    DynamicFormComponent
  ],
  entryComponents: [
    FormButtonComponent,
    FormInputComponent,
    FormSelectComponent,
    FormAddressComponent,
    FormDateComponent,
    FormPasswordComponent,
    FormLinkComponent,
    FormTextAreaComponent,
    FormNumberComponent
  ]
})
export class DynamicFormModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/dynamic-form/dynamic-form.module.ts